import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=46813bc4&scoped=true"
import script from "./Reset.vue?vue&type=script&setup=true&lang=js"
export * from "./Reset.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Reset.vue?vue&type=style&index=0&id=46813bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46813bc4",
  null
  
)

export default component.exports